import apiClient from "../utils/apiUtils";

// Assign a role to a user
export const assignRoleToUser = async (token, data) => {
  try {
    const response = await apiClient.post(`/assign-role`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Assign or remove permissions from a role (Create/General management)
export const assignPermissionsToRole = async (token, data) => {
  try {
    const response = await apiClient.post(`/assign-permission-role`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Fetch role info with specific permission data
export const getRolePermissionDetails = async (token, roleId) => {
  try {
    const response = await apiClient.get(`/roles/${roleId}/permissions`);
    // The API returns the role data inside a "data" property
    return response.data.data || response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update existing role permissions (Diff-based)
// Uses POST with _method override to bypass CORS restriction on PATCH
export const updateRolePermissions = async (token, roleId, data) => {
  try {
    const response = await apiClient.post(`/roles/${roleId}/permissions`, {
      ...data,
      _method: "PATCH",
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Assign or remove permissions from a user
export const assignPermissionsToUser = async (token, data) => {
  try {
    const response = await apiClient.post(`/assign-permission-user`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
